<div class="w-full flex flex-col gap-4 p-4">
    <div class="w-full flex sm:flex-row flex-col items-center justify-between gap-4">
        <h1 class="text-2xl font-bold">Bancos</h1>

        <app-button
            (click)="incluir()"
            variant="success"
            class="md:max-w-45 w-full"
        >
            Incluir
        </app-button>
    </div>

    <app-input-search
        [(ngModel)]="filtro"
        label="Pesquisar Banco"
        class="w-full"
    ></app-input-search>

    <p-table
        [paginator]="true"
        [rows]="qtdLinhas || 7"
        [totalRecords]="usuarios.length"
        [value]="usuarios"
        [lazy]="false"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[15%] min-w-20">Código</th>
                <th class="w-[75%] min-w-40">Nome</th>
                <th class="w-[10%] min-w-10">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.Codigo }}</td>
                <td>{{ rowData.Nome }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
